import React from 'react';

const CaseNotesHelp = () => (
  <div>
    <h2>Case notes best practices</h2>
    <p>
      Use case notes to capture internal updates that keep the rest of the team aligned. Notes are only visible to
      staff and form the running history of decisions, conversations, and follow-ups.
    </p>

    <h3>How to use this widget</h3>
    <ul>
      <li>
        <strong>Add context quickly:</strong> Click <em>New note</em> to log meeting summaries, phone calls, or
        reminders, then choose <em>Save note</em>.
      </li>
      <li>
        <strong>Edit or delete responsibly:</strong> You can revise or remove your own entries when mistakes occur,
        but aim to preserve a clear audit trail.
      </li>
      <li>
        <strong>Pin important updates:</strong> Pinned notes stay at the top, making critical instructions easy to
        find.
      </li>
      <li>
        <strong>Set follow-up dates:</strong> Adding a date reveals separate <strong>Title</strong> and <strong>Details</strong> fields.
        Give the reminder a short action title; it appears in the Case Calendar and Reminders dashboard.
        Put the supporting context in Details. You can edit either field separately. Acknowledge the reminder once the task is complete.
      </li>
      <li>
        <strong>Refresh anytime:</strong> Use the refresh icon after collaborating with others to see their latest
        additions.
      </li>
    </ul>

    <h3>Writing effective notes</h3>
    <ul>
      <li>Lead with the outcome or decision, then add relevant details.</li>
      <li>Record dates, follow-up owners, and deadlines where possible.</li>
      <li>Use notes to record applicant contact, missing-document follow-up, and key case-management decisions when those details matter to the audit trail.</li>
      <li>Avoid sensitive personal data - store documents in the Supporting Documents widget instead.</li>
    </ul>

    <h3>Need inspiration?</h3>
    <p>
      Think of case notes as the hand-off briefing between teammates. A clear note answers "what changed, why it
      matters, and what happens next."
    </p>
  </div>
);

CaseNotesHelp.aiContext = `
You are assisting an ISET program coordinator using the Case Notes widget. Explain how to add, edit, and pin notes,
how follow-up dates create reminders, and when to refresh. Setting a follow-up date reveals a required Title (up to 255 characters) and Details. Title supplies the calendar/day-view and Reminders dashboard heading; Details remains the case note text. Editing Details does not rename the reminder. Existing reminders retain their saved titles and original note text. Notes without a follow-up date need only Note text. System-generated reminders receive titles/details from their triggering workflow. Emphasise collaborative record-keeping and avoiding
sensitive data, and remind them they can acknowledge reminders once the task is complete. When relevant, encourage the
user to record applicant contact, follow-up attempts, and key decisions so the file maintains a clear audit trail.
`;

export default CaseNotesHelp;
